import Component from '../../../shared/component';

export default class GroupsSearch extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element).find('.groupsSearch-field');
    this.$templateElement = $(element).find('.groupsSearch-suggestionTemplate');
    this.url = this.$element.data('url');

    this.bindEvents();
  }

  bindEvents() {
    const typeaheadOptions = {
      autoselect: true,
      hint: false,
      highlight: true,
    };

    this.bloodhoundEngine = this.getTypeaheadSource();
    this.typeaheadInstance = this.$element.typeahead(
      typeaheadOptions,
      this.getTypeaheadSourceOptions()
    );

    this.handleAutoCompleteSelect = this.handleAutoCompleteSelect.bind(this);

    this.typeaheadInstance.on(
      'typeahead:selected',
      this.handleAutoCompleteSelect
    );
  }

  unbindEvents() {
    this.bloodhoundEngine = null;
    this.typeaheadInstance.off(
      'typeahead:selected',
      this.handleAutoCompleteSelect
    );
    this.$element.typeahead('destroy');
  }

  getTypeaheadSourceOptions() {
    const templateElement = this.$templateElement.clone().html();

    return {
      name: 'states',
      displayKey: 'name',
      source: this.bloodhoundEngine.ttAdapter(),
      templates: {
        suggestion: (item) => {
          let template = templateElement;
          template = template.replace('__group_name__', item.name);
          template = template.replace(
            '__group_memberships_count__',
            item.groupMembershipsCount
          );
          template = template.replace(
            '__group_messages_count__',
            item.groupMessagesCount
          );

          if (item.currentUserMembership) {
            template = template.replace(
              'groupsSearch-suggestion"',
              'groupsSearch-suggestion groupsSearch-suggestion--member"'
            );
          }

          return template;
        },
      },
    };
  }

  getTypeaheadSource() {
    const source = new window.Bloodhound({
      datumTokenizer: window.Bloodhound.tokenizers.whitespace('name'),
      queryTokenizer: window.Bloodhound.tokenizers.whitespace,
      limit: Infinity,
      remote: {
        wildcard: '%QUERY',
        url: `${this.$element.data('url')}?q=%QUERY`,
        filter: (parsedResponse) => this.filterRemoteGroups(parsedResponse),
      },
    });

    source.initialize();

    return source;
  }

  filterRemoteGroups(parsedResponse) {
    return parsedResponse.groups.map((item) => {
      return {
        id: item.group.slug,
        name: item.group.name,
        groupMembershipsCount: item.group.group_memberships_count,
        groupMessagesCount: item.group.group_messages_count,
        currentUserMembership: item.group_membership,
      };
    });
  }

  handleAutoCompleteSelect(_, datum) {
    this.$element.val('');
    window.Turbolinks.visit(`/groupes-de-discussion/${datum.id}`);
  }
}
